// @flow
import client from '../../client'

/**
 * Get the terms and condition from a endpoint
 * @param {Object} data Query data
 * @param {string} data.endpoint The endpoint that will retrieve the terms
 * @return {Promise|Error} A resolved Promise with terms or Rejected with an Error
 */
export const getTermsAndConditions = (data: {
  endpoint: string,
}): Promise<any> => client.get(data.endpoint)

export default getTermsAndConditions
